import { RuleParamSchema } from "vee-validate/dist/types/types";
import { isUndefinedOrNullOrEmptyString } from "@/module/Validation/rules/isUndefinedOrNullOrEmptyString";

const validate = (value: any, { min }: Record<string, any>): boolean => {
  if (isUndefinedOrNullOrEmptyString(value)) {
    return false;
  }

  if (Array.isArray(value)) {
    return value.length > 0 && value.every((val) => validate(val, { min }));
  }

  value = String(value).replace(",", ".");

  if (value === "") {
    return false;
  }

  return Number(value) >= min;
};

const params: RuleParamSchema[] = [
  {
    name: "min",
  },
];

export { validate, params };

export default {
  validate,
  params,
};
